import { render, staticRenderFns } from "./HeaderSystemMessages.vue?vue&type=template&id=50adaf14&scoped=true&"
import script from "./HeaderSystemMessages.vue?vue&type=script&lang=js&"
export * from "./HeaderSystemMessages.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSystemMessages.vue?vue&type=style&index=0&id=50adaf14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50adaf14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50adaf14')) {
      api.createRecord('50adaf14', component.options)
    } else {
      api.reload('50adaf14', component.options)
    }
    module.hot.accept("./HeaderSystemMessages.vue?vue&type=template&id=50adaf14&scoped=true&", function () {
      api.rerender('50adaf14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/system/HeaderSystemMessages.vue"
export default component.exports